module.exports = __webpack_public_path__ + "img/a4.8ec28192.png";